import React from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";

import QuestionPoint from "./QuestionPoint";

const coordinates = [
    {x: 124, y: 25},
    {x: 173, y: 121},
    {x: 80, y: 204},
    {x: 150, y: 67},
    {x: 15, y: 139},
    {x: 197, y: 80},
    {x: 39, y: 181},
    {x: 78, y: 111},
    {x: 124, y: 112},
    {x: 184, y: 169},
    {x: 127, y: 203},
    {x: 89, y: 158},
    {x: 32, y: 90},
    {x: 137, y: 158},
    {x: 102, y: 69}
];

const Society = (props) => {
    return (
        <svg viewBox="0 0 260 260">
            <g className="society">
                <g className="points">
                    <circle fill="#FFFFFF" cx="47.9" cy="36.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="38.4" cy="45.5" r="1.2"/>
                    <circle fill="#FFFFFF" cx="29.8" cy="55.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="22.3" cy="65.9" r="1.2"/>
                    <circle fill="#FFFFFF" cx="16" cy="77.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="10.9" cy="89.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="7.1" cy="101.5" r="1.2"/>
                    <circle fill="#FFFFFF" cx="4.5" cy="114.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="3.4" cy="127.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="3.5" cy="140" r="1.2"/>
                    <circle fill="#FFFFFF" cx="5.1" cy="152.9" r="1.2"/>
                    <circle fill="#FFFFFF" cx="7.9" cy="165.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="12.1" cy="177.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="17.5" cy="189.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="24.2" cy="200.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="31.9" cy="211.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="40.7" cy="220.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="50.5" cy="229.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="61.1" cy="236.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="72.4" cy="243" r="1.2"/>
                    <circle fill="#FFFFFF" cx="84.3" cy="248.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="96.7" cy="251.9" r="1.2"/>
                    <circle fill="#FFFFFF" cx="109.4" cy="254.5" r="1.2"/>
                    <circle fill="#FFFFFF" cx="122.3" cy="255.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="135.3" cy="255.5" r="1.2"/>
                    <circle fill="#FFFFFF" cx="148.1" cy="253.9" r="1.2"/>
                    <circle fill="#FFFFFF" cx="160.8" cy="251.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="173.1" cy="246.9" r="1.2"/>
                    <circle fill="#FFFFFF" cx="184.8" cy="241.5" r="1.2"/>
                    <circle fill="#FFFFFF" cx="196" cy="234.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="206.4" cy="227.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="215.9" cy="218.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="224.4" cy="208.5" r="1.2"/>
                    <circle fill="#FFFFFF" cx="231.9" cy="197.9" r="1.2"/>
                    <circle fill="#FFFFFF" cx="238.2" cy="186.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="243.3" cy="174.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="247.2" cy="162.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="249.7" cy="149.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="250.9" cy="136.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="250.7" cy="123.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="249.2" cy="110.9" r="1.2"/>
                    <circle fill="#FFFFFF" cx="246.3" cy="98.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="242.1" cy="85.9" r="1.2"/>
                    <circle fill="#FFFFFF" cx="236.7" cy="74.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="230.1" cy="63" r="1.2"/>
                    <circle fill="#FFFFFF" cx="222.3" cy="52.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="213.5" cy="43.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="203.7" cy="34.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="193.2" cy="27.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="58.3" cy="28.9" r="1.2"/>
                    <path fill="#FFFFFF" d="M68.8,20.3l2-1l0.2,0.4c0.1,0.3,0.3,0.5,0.5,0.6c0.2,0.1,0.5,0.1,0.7,0c0.4-0.2,0.6-0.6,0.3-1.2l-1.9-3.9
    l-2.2,1.1l-0.8-1.7l4.2-2l2.8,5.7c0.9,1.8-0.1,3.3-1.5,4c-1.4,0.7-3.2,0.4-4-1.3L68.8,20.3z"/>
                    <path fill="#FFFFFF" d="M78.9,15L78.9,15l0-0.1c-0.2-0.5-0.7-0.5-1.2-0.3c-0.8,0.3-1.4,1.3-1.4,1.3l-1.3-1.1
    c0.5-0.8,1.3-1.5,2.2-1.9c1.7-0.7,3.1-0.2,3.8,1.3l1.5,3.7l-1.9,0.8l-0.2-0.4c-0.1-0.1-0.1-0.3-0.1-0.4l0,0c0,0-0.1,1.1-1.4,1.6
    c-1.1,0.5-2.4,0.1-2.9-1.1C75.5,16.6,78,15.4,78.9,15z M79,17.7c0.5-0.2,0.8-1,0.6-1.5l-0.1-0.1l-0.2,0.1
    c-0.6,0.3-1.3,0.8-1.1,1.3C78.3,17.7,78.6,17.9,79,17.7L79,17.7z"/>
                    <path fill="#FFFFFF" d="M84.4,7.6l2-0.7L87,8.5l-2,0.7L84.4,7.6z M85.2,10l2.1-0.7l2.1,6.2l-2.1,0.7L85.2,10z"/>
                    <path fill="#FFFFFF" d="M94,11.7c0,0,0.9,0.5,1.8,0.2c0.3-0.1,0.6-0.2,0.6-0.5c-0.1-0.6-3.1,0.2-3.7-1.9c-0.3-1.2,0.6-2.2,2.1-2.6
    c1.5-0.4,2.4,0.2,2.4,0.2l-0.3,1.7c-0.5-0.2-1.1-0.3-1.6-0.1c-0.3,0.1-0.6,0.3-0.5,0.5c0.1,0.5,3.1-0.2,3.7,1.8
    c0.3,1.1-0.4,2.3-2.1,2.7c-0.9,0.2-1.9,0.1-2.8-0.3L94,11.7z"/>
                    <path fill="#FFFFFF" d="M98.7,6.1l2-0.4l0.1,0.3c0,0.1,0,0.3,0.1,0.4h0c0,0,0.4-1,1.8-1.3c1.8-0.3,3.2,0.8,3.6,2.8
    c0.4,2-0.6,3.6-2.3,4c-0.6,0.1-1.2,0-1.8-0.3h0c0,0,0.1,0.2,0.1,0.5l0.5,2.4l-2.2,0.4L98.7,6.1z M103.1,10.3
    c0.7-0.1,1.2-0.8,1-1.8c-0.2-1-0.8-1.5-1.6-1.3c-0.7,0.1-1.2,0.7-0.9,1.8C101.6,9.8,102.2,10.4,103.1,10.3L103.1,10.3z"/>
                    <path fill="#FFFFFF" d="M110.4,4c2.1-0.3,3.9,0.9,4.2,2.9s-1.2,3.6-3.3,3.9s-3.9-0.9-4.1-2.9C106.9,5.8,108.4,4.2,110.4,4z
     M111.1,9c0.8-0.1,1.4-0.8,1.3-1.8s-0.9-1.5-1.7-1.4s-1.4,0.8-1.3,1.8S110.3,9.1,111.1,9z"/>
                    <path fill="#FFFFFF" d="M115.5,5.5l0.6-0.4L115.8,1l2.2-0.2l0.2,2.9l0.8-0.6l0.2,2.1l-0.8,0.6l0.1,1.4c0,0.6,0.2,0.8,0.7,0.8
    c0.1,0,0.3,0,0.3,0l0.1,1.9c-0.2,0-0.4,0.1-0.7,0.1c-1.2,0.1-2.4-0.1-2.6-2.3l0-0.4l-0.6,0.4L115.5,5.5z"/>
                    <path fill="#FFFFFF" d="M123.7,2.9c1.9-0.1,3.1,1.3,3.1,3.1c0,0.2,0,0.7,0,0.7l-4.1,0.1c0.2,0.8,0.9,1.2,1.6,1.1
    c0.9,0,1.8-0.7,1.8-0.7l0.9,1.5c-0.8,0.7-1.8,1-2.8,1c-2.3,0.1-3.7-1.6-3.7-3.3C120.4,4.5,121.6,3,123.7,2.9z M124.6,5.5
    c0-0.5-0.4-0.9-0.9-0.9c-0.6,0-0.9,0.5-1,1L124.6,5.5z"/>
                    <path fill="#FFFFFF" d="M131.6,3c1.8,0.1,2.6,1.1,2.6,1.1l-1,1.4c-0.4-0.4-1-0.6-1.5-0.7c-1,0-1.6,0.7-1.6,1.5
    c0,0.8,0.5,1.7,1.6,1.7c0.9,0,1.8-0.7,1.8-0.7l0.8,1.6c0,0-1,1.1-2.9,1c-2.3-0.1-3.6-1.7-3.6-3.6C127.9,4.5,129.3,2.9,131.6,3z"/>
                    <path fill="#FFFFFF" d="M135.1,8.7l2.7-2.8c0.2-0.2,0.4-0.4,0.6-0.5v0c-0.2,0-0.4,0-0.6,0l-2.3-0.2l0.2-1.8l5.8,0.5l-0.1,1.1
    l-2.6,2.8c-0.2,0.2-0.4,0.4-0.6,0.5v0c0.2,0,0.4,0,0.6,0l2.5,0.2l-0.2,1.8l-6-0.5L135.1,8.7z"/>
                    <path fill="#FFFFFF" d="M146,4.3c1.9,0.3,2.8,1.8,2.5,3.6c0,0.2-0.2,0.7-0.2,0.7l-4.1-0.6c0,0.8,0.7,1.3,1.3,1.4
    c0.9,0.1,1.9-0.4,1.9-0.4l0.6,1.6c-0.9,0.5-1.9,0.7-2.9,0.5c-2.3-0.3-3.3-2.2-3.1-3.9C142.4,5.3,143.9,4,146,4.3z M146.5,7
    c0.1-0.5-0.2-1-0.7-1.1c-0.6-0.1-1,0.3-1.2,0.8L146.5,7z"/>
                    <path fill="#FFFFFF" d="M150.7,5.2l2.1,0.4l-0.1,0.6c0,0.1-0.1,0.3-0.1,0.4h0c0.4-0.4,1.1-0.9,2.3-0.7c1.3,0.3,2.2,1.1,1.8,2.9
    l-0.9,4.2l-2.2-0.5l0.8-3.8c0.1-0.6-0.1-0.9-0.5-1c-0.6-0.2-1.2,0.1-1.5,0.7c-0.1,0.3-0.3,0.5-0.3,0.8l-0.6,2.8l-2.2-0.5
    L150.7,5.2z M154.6,3.4l2.1,0.5l-1.9,1.6L153.2,5L154.6,3.4z"/>
                    <path fill="#FFFFFF" d="M158.4,11.3c0,0,0.5,0.8,1.4,1.1c0.3,0.1,0.7,0.1,0.7-0.1c0.2-0.6-2.8-1.4-2.2-3.5
    c0.3-1.2,1.7-1.6,3.1-1.2c1.5,0.4,2,1.3,2,1.3l-1.1,1.3c-0.3-0.4-0.8-0.8-1.4-0.9c-0.3-0.1-0.7-0.1-0.7,0.1
    c-0.1,0.5,2.8,1.4,2.3,3.4c-0.3,1.1-1.5,1.7-3.1,1.3c-0.9-0.2-1.7-0.8-2.3-1.6L158.4,11.3z"/>
                    <path fill="#FFFFFF" d="M164.9,10.6l-0.8-0.3l0.5-1.6l0.9,0.3l0.6-1.8l2,0.7l-0.6,1.8l1.3,0.4l-0.5,1.6l-1.3-0.4l-0.6,1.9
    c-0.2,0.7,0.5,1,0.9,1.2c0.1,0,0.2,0.1,0.3,0.1l-0.6,1.8c-0.2,0-0.4-0.1-0.6-0.2c-1-0.3-2.8-1.2-2.2-3.3L164.9,10.6z"/>
                    <path fill="#FFFFFF" d="M170,10.3l2.2,0.9l-0.7,3.9c0,0.2-0.1,0.5-0.2,0.7l0,0c0.1-0.2,0.2-0.4,0.4-0.6l2.3-3.3l1.8,0.7l-0.6,3.9
    c0,0.2-0.1,0.5-0.2,0.7l0,0c0.1-0.2,0.2-0.4,0.3-0.6l2.2-3.3l2.1,0.9l-4.1,5.4l-2.3-0.9l0.4-3.1c0-0.2,0.1-0.5,0.1-0.7l0,0
    c-0.1,0.2-0.2,0.4-0.4,0.6l-1.8,2.5l-2.3-0.9L170,10.3z"/>
                    <path fill="#FFFFFF" d="M183.8,16c1.9,0.9,2.7,2.9,1.8,4.8c-0.9,1.9-3,2.3-4.9,1.4c-1.9-0.9-2.7-2.9-1.8-4.7
    C179.8,15.6,181.9,15.1,183.8,16z M181.6,20.5c0.7,0.4,1.6,0.1,2-0.8s0.1-1.8-0.6-2.1c-0.7-0.4-1.6-0.1-2.1,0.8
    C180.5,19.3,180.8,20.2,181.6,20.5L181.6,20.5z"/>
                </g>
                { props.survey.map((question, index) => {
                    return <QuestionPoint key={question.id} code={question.code} area="society" percent={question.answers[0].percent}
                                          x={coordinates[index].x} y={coordinates[index].y}/>
                }) }
            </g>
        </svg>
    );
};

const mapStateToProps = (state) => {
    return {
        survey: state.survey.society.questions,
    }
};

export default connect(mapStateToProps)(Society);


Society.defaultProps = {
    click: () => {},
};

Society.propTypes = {
    click: PropTypes.func,
};


// WEBPACK FOOTER //
// ./sources/js/components/Summary/graph/Society.js